var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgCompass = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 24 24",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("path", {
    fill: props.color || 'currentColor',
    fillRule: "evenodd",
    d: "M12,22.75 C6.06293894,22.75 1.25,17.9370611 1.25,12 C1.25,6.06293894 6.06293894,1.25 12,1.25 C17.9370611,1.25 22.75,6.06293894 22.75,12 C22.75,17.9370611 17.9370611,22.75 12,22.75 Z M12,21.25 C17.1086339,21.25 21.25,17.1086339 21.25,12 C21.25,6.89136606 17.1086339,2.75 12,2.75 C6.89136606,2.75 2.75,6.89136606 2.75,12 C2.75,17.1086339 6.89136606,21.25 12,21.25 Z M16.9515125,7.99717082 L14.8315125,14.3571708 C14.7568612,14.5811246 14.5811246,14.7568612 14.3571708,14.8315125 L7.99717082,16.9515125 C7.4108523,17.146952 6.85304802,16.5891477 7.04848753,16.0028292 L9.16848753,9.64282918 C9.24313878,9.41887543 9.41887543,9.24313878 9.64282918,9.16848753 L16.0028292,7.04848753 C16.5891477,6.85304802 17.146952,7.4108523 16.9515125,7.99717082 Z M10.4729271,10.4729271 L8.94585412,15.0541459 L13.5270729,13.5270729 L15.0541459,8.94585412 L10.4729271,10.4729271 Z"
  }));
};
export default SvgCompass;